import {FAILURE_COPY} from '@product/quies/components/Failures/failureCopy'
import type {InterfaceStrings} from './strings'

export const en: InterfaceStrings = {
    nav: {
        beginSession: 'Begin Session',
        faq: 'FAQ',
        pricing: 'Pricing',
        legal: 'Legal',
        signIn: 'Sign in',
        viewPricing: 'View Pricing',
        signOut: 'Sign out',
        account: 'Account',
        menu: 'Menu',
        closeMenu: 'Close menu',
        mainNav: 'Main',
        sessions: {one: '{n} session', other: '{n} sessions'},
    },
    footer: {
        selfHypnosisFor: 'Self-Hypnosis For',
        anxiety: 'Anxiety',
        sleep: 'Sleep',
        stress: 'Stress',
        confidence: 'Confidence',
        focus: 'Focus',
        learn: 'Learn',
        ericksonian: 'What Is Ericksonian Hypnosis',
        aiHow: 'How AI Hypnosis Works',
        vsMeditation: 'Hypnosis vs Meditation',
        methods: 'Methods',
        languages: 'Languages',
    },
    page: {
        cta: 'Begin your free session',
        hint: 'Your first session is free',
        exploreFurther: 'Explore Further',
        disclaimer:
            'Quies is a wellness tool for relaxation and self-exploration. It is not a medical device and does not diagnose, treat, or cure any condition. If you are experiencing a mental health crisis, please contact a qualified healthcare professional.',
        transcript: 'Transcript',
        transcriptNote: 'An excerpt from a real Quies session, as it was spoken.',
        breadcrumb: 'Breadcrumb',
    },
    pricing: {
        selectPlan: 'Select Plan',
        subscribe: 'Subscribe',
        perMonth: 'a month',
        manageSubscription: 'Manage your subscription',
        replayFree: 'Listening again to a past session is always free.',
        offerLead: 'Each session starts from where the last one ended.',
    },
    session: {
        chooseLanguage: 'Choose your language',
        changeLanguage: 'Change language',
        changeVoice: 'Change voice',
        previewVoice: 'Preview {voice}',
        stopPreview: 'Stop preview',
        continue: 'Continue',
        composing: 'Quies is composing',
        preparing: 'Preparing your meditation',
        pickingUp: 'picking up where you left off',
        today: 'Today',
        yesterday: 'Yesterday',
        loading: 'Loading...',
        showEarlier: 'Show earlier ({count} more)',
        tryDifferentApproach: 'Try a different approach',
        nothingAdded: 'Nothing added',
        purchaseConfirmed: 'Purchase confirmed',
        firstSessionNote: 'Your first session is free. You will sign in before you listen.',
    },
    threshold: {
        title: 'Sign in to listen',
        message: 'Your first session is free. No card needed.',
        google: 'Continue with Google',
        sendLink: 'Send me a sign-in link',
        sending: 'Sending…',
        emailLabel: 'Email address',
        or: 'or',
        waitingTitle: 'Check your email',
        waitingBody: 'We sent a sign-in link to {email}.',
        sendAgain: 'Send again',
        googleInstead: 'Sign in with Google instead',
        codeLabel: 'Or type the 6-digit code from the email',
        codeSubmit: 'Continue',
        codeSubmitting: 'Checking…',
        codeWrong: 'This code is not right.',
        codeDead: 'This code no longer works. Use the link in the email, or send a new one.',
        errors: {
            invalidEmail: 'Enter a valid email address.',
            rateLimited: 'Too many attempts. Try again in a few minutes.',
            sessionError: 'Something went wrong with your session. Refresh the page and try again.',
            sendFailed: 'The email could not be sent. Please try again.',
            sessionExpired: 'Your session expired. Refresh the page and try again.',
            generic: 'Something went wrong. Please try again.',
        },
    },
    player: {
        play: 'Play',
        pause: 'Pause',
        playAgain: 'Play again',
        seek: 'Seek',
        eyesClosed: 'Eyes closed',
        openEyes: 'Open eyes',
        paused: 'Paused',
        unavailable: 'Audio unavailable',
        untitled: 'Quies Session',
    },
    failure: FAILURE_COPY,
}
